var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_91_770)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_91_770)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.333496,
    width: 24,
    height: 24,
    rx: 6,
    fill: "url(#paint0_linear_91_770)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.3335 14.0441H10.0954L9.94535 14.229L9.3259 14.9918L9.32535 14.9925L8.96034 15.4404C8.96023 15.4405 8.96012 15.4407 8.96001 15.4408C8.88722 15.5289 8.74051 15.5214 8.68287 15.3958C8.6827 15.3954 8.68254 15.3951 8.68237 15.3947L7.79044 13.3868L7.73544 13.2629L7.62543 13.1838C6.53148 12.3971 5.8335 11.1589 5.8335 9.77207C5.8335 7.43194 7.82711 5.5 10.3335 5.5C12.1582 5.5 13.7202 6.53138 14.4155 7.98979L14.4154 7.98981L14.4186 7.99624C14.6855 8.53598 14.8335 9.13524 14.8335 9.77207C14.8335 12.1122 12.8399 14.0441 10.3335 14.0441Z",
    fill: "white",
    stroke: "#FF6ABD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5002 12.5735C18.5002 14.1002 17.7135 15.4535 16.5002 16.3069L15.6069 18.2735C15.4002 18.7202 14.8002 18.8069 14.4869 18.4269L13.5002 17.2402C11.8869 17.2402 10.4469 16.5269 9.54688 15.4135L10.1669 14.6669C12.9269 14.6669 15.1669 12.5802 15.1669 10.0002C15.1669 9.30021 15.0002 8.64021 14.7002 8.04688C16.8802 8.54688 18.5002 10.3869 18.5002 12.5735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 10.5H11.8333C12.1067 10.5 12.3333 10.2733 12.3333 10C12.3333 9.72667 12.1067 9.5 11.8333 9.5H8.5C8.22667 9.5 8 9.72667 8 10C8 10.2733 8.22667 10.5 8.5 10.5Z",
    fill: "#FF73CA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_91_770",
    x: 0.333496,
    y: 0,
    width: 24,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.791903 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_91_770"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_91_770",
    x1: 0.333496,
    y1: 0,
    x2: 0.333496,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF81DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4B94"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_91_770"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.333496)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCs);
export default __webpack_public_path__ + "static/media/cs.eab99e5ec5ac8fa2a7c58c0e41b83c36.svg";
export { ForwardRef as ReactComponent };